/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-case-declarations */
import { POOL_REQUESTS_TAB_ID } from 'Constants/consults';

import * as ACTION_TYPES from './types';

const initialState = {
  uploading: false,
  bubbles: [],
  focusedChat: null,
  uploadGroup: null,
  activeTab: null,
  activeClinicTab: POOL_REQUESTS_TAB_ID,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.MESSAGE_UPLOADING_FILE:
      return {
        ...state,
        uploading: !state.uploading,
      };
    case ACTION_TYPES.BUBBLE_CHAT_ADD:
      const draft = state.bubbles.map((bubble, i) =>
        i > 0 ? { id: bubble.id, isMinimum: true } : { id: bubble.id, isMinimum: bubble.isMinimum },
      );
      return {
        ...state,
        bubbles:
          state.bubbles?.map(bubble => bubble.id).indexOf(payload.id) === -1
            ? [{ id: payload.id }, ...draft]
            : state.bubbles,
      };
    case ACTION_TYPES.BUBBLE_CHAT_REMOVE:
      // localStorage.setItem('manadr.bubbles', JSON.stringify(state.bubbles.filter(e => e !== payload.id)));
      return {
        ...state,
        bubbles: state.bubbles.filter(e => e.id !== payload.id),
      };

    case ACTION_TYPES.BUBBLE_CHAT_CLEAR:
      return {
        ...state,
        bubbles: [],
      };

    case ACTION_TYPES.BUBBLE_CHAT_TO_MINIMUM:
      return {
        ...state,
        bubbles: state.bubbles
          .map(e => (e.id === payload.id ? { ...e, isMinimum: true } : e))
          .sort((x, y) => x?.isMinimum || false - y?.isMinimum || false),
      };
    case ACTION_TYPES.MINIMUM_CHAT_TO_BUBBLE: {
      const currentChat = state.bubbles?.find(bubble => bubble?.id === payload.id);
      const temp = state.bubbles.map((bubble, i) =>
        i > 0 ? { ...bubble, isMinimum: true } : bubble,
      );
      return {
        ...state,
        bubbles: [
          { ...currentChat, isMinimum: false },
          ...temp?.filter(bubble => bubble.id !== payload.id),
        ],
      };
    }
    case ACTION_TYPES.BUBBLE_CHAT_LOAD:
      return {
        ...state,
        bubbles: payload.bubbles,
      };
    case ACTION_TYPES.MINIMUM_CHAT_FOCUSED:
      return {
        ...state,
        focusedChat: payload.id,
      };
    case ACTION_TYPES.MINIMUM_UPLOAD_GROUP:
      return {
        ...state,
        uploadGroup: payload.id,
      };
    case ACTION_TYPES.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: {
          groupId: payload.groupId,
          tab: payload.tab,
        },
      };

    case ACTION_TYPES.SET_ACTIVE_CLINIC_TAB:
      return {
        ...state,
        activeClinicTab: payload.clinicId,
      };
    default:
      return state;
  }
}
